module.exports = __webpack_public_path__ + "static/media/gameBanner.382f28cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/gameBanner.jpg
// module id = 1946
// module chunks = 0